import {Component, ViewChild, computed, inject} from '@angular/core';
import {ActionDisabledComponent} from '@xmedical/ui';
import {PatientStore, PatientTreatmentPlansStore} from '../../../core/state';

@Component({
    selector: 'app-patient-treatment-plans-widget',
    templateUrl: './treatment-plans-widget.component.html',
    styleUrls: ['./treatment-plans-widget.component.scss'],
    standalone: false
})
export class TreatmentPlansWidgetComponent {

  error = '';
  @ViewChild(ActionDisabledComponent) disabledDialog: ActionDisabledComponent;

  private patientStore = inject(PatientStore);
  protected plansStore = inject(PatientTreatmentPlansStore);

  readonly plans = computed(() => this.plansStore.items());
  readonly loading = computed(() => this.plansStore.loading());

  get hasError(): boolean {
    return this.error.length > 0;
  }

  get hasPlans(): boolean {
    return this.plansStore.count() > 0;
  }

  get patientId(): number {
    return this.patientStore.current()?.id ?? 0;
  }
}
